import BaseAPI from './BaseAPI';
import Scenario from '../models/Scenario';


export class ScenarioAPI extends BaseAPI {

	async getScenarios() {
		return this.request('/-/scenario', 'GET');
	}
	async getMultiTenantCode() {
		return this.request('/-/scenario/multiTenantCode', 'GET');
	}
	async getTemplates(language) {
		return this.request(`/-/scenario/template?language=${language || 'en'}`, 'GET');
	}
	async saveTemplate(name, scenario) {
		scenario = scenario.set('name', name);
		return this.request('/-/scenario/template', 'PUT', {scenario: scenario.toJS()});
	}
	async createWebhookCode() {
		return this.request('/-/webhook', 'GET');
	}
	async createEmail() {
		return this.request('/-/scenario/email', 'GET');
	}
	async updateScenario(scenario: Scenario) {
		await this.request('/-/scenario', 'PUT', { scenario: scenario.toJS() });
	}
	async newScenario(scenario: Scenario) {
		await this.request('/-/scenario', 'POST', { scenario: scenario.toJS() });
	}
	async deleteScenario(scenario: Scenario) {
		await this.request('/-/scenario', 'DELETE', { id: scenario.id });
	}
	async refreshScenario(scenario: Scenario) {
		await this.request(`/-/scenario/${scenario.get('id')}`, 'GET');
	}
	async testAction(scenario: Scenario) {
		await this.request('/-/scenario/test', 'POST', { scenario: scenario.toJS() });
	}
	async startScenario(scenarioIds, payload, pageId) {
		await this.request('/-/scenario/start', 'POST', { scenarioIds, payload, pageId });
	}

	async getScenarioRecipients(actionConfig, scenarioId) {
		return await this.request(`/-/scenario/${scenarioId}/action/recipients`, 'POST', actionConfig);
	}
}
